import React from "react";
import { FACE_DETECTION_CONFIG } from "../../FaceValidation/constants";

const EnhancedFaceGuide = ({
  isValid,
  currentFaceData = null,
  videoSize = { width: 100, height: 100 },
  isFrontCamera = true,
  // Control ellipse size - percentages of screen size
  ellipseWidth = 45, // Ellipse width in percentage (45% = almost half screen)
  ellipseHeight = 60, // Ellipse height in percentage (60% = slightly more than half)
}) => {
  // Get configuration values
  const minRatio = FACE_DETECTION_CONFIG.ratio.min; // 0.225
  const maxRatio = FACE_DETECTION_CONFIG.ratio.max; // 0.4

  // Determine current face status for visual feedback
  let faceStatus = "none";
  let showCenteringGuides = false;
  if (currentFaceData && currentFaceData.ratio) {
    const ratio = currentFaceData.ratio;

    // Check if not centered or too close to edges
    if (!currentFaceData.centered || !currentFaceData.inFrame) {
      showCenteringGuides = true;
      faceStatus = "not-centered";
    } else if (ratio < minRatio) {
      faceStatus = "too-far";
    } else if (ratio > maxRatio) {
      faceStatus = "too-close";
    } else {
      faceStatus = isValid ? "perfect" : "good";
    }
  }

  return (
    <div
      className={`enhanced-face-guide-overlay ${
        isFrontCamera ? "front-camera" : "back-camera"
      }`}
    >
      {/* Center crosshair - shows where to position face */}
      <div className={`center-crosshair ${!isValid ? "pulsing" : ""}`}>
        <div className="crosshair-vertical"></div>
        <div className="crosshair-horizontal"></div>
      </div>
      {/* Main boundary overlay - dark screen with elliptical hole */}
      <div
        className="boundary-overlay"
        style={{
          "--ellipse-width": `${ellipseWidth}%`,
          "--ellipse-height": `${ellipseHeight}%`,
        }}
      />
      {/* Current face outline (if detected) */}
      {currentFaceData && currentFaceData.box && (
        <div
          className={`current-face-outline ${faceStatus}`}
          style={{
            left: `${(currentFaceData.box.x / videoSize.width) * 100}%`,
            top: `${(currentFaceData.box.y / videoSize.height) * 100}%`,
            width: `${(currentFaceData.box.width / videoSize.width) * 100}%`,
            height: `${(currentFaceData.box.height / videoSize.height) * 100}%`,
          }}
        />
      )}
      {/* Visual instructions */}
      <div className="visual-instructions">
        <div
          className={`instruction-item ${
            faceStatus === "not-centered" ? "highlighted" : ""
          }`}
        >
          <div className="instruction-color not-centered-color"></div>
          <span>מרכז פנים</span>
        </div>
        <div
          className={`instruction-item ${
            faceStatus === "too-far" ? "highlighted" : ""
          }`}
        >
          <div className="instruction-color too-far-color"></div>
          <span>התקרב</span>
        </div>
        <div
          className={`instruction-item ${
            faceStatus === "perfect" || faceStatus === "good"
              ? "highlighted"
              : ""
          }`}
        >
          <div className="instruction-color ideal-color"></div>
          <span>מושלם</span>
        </div>
        <div
          className={`instruction-item ${
            faceStatus === "too-close" ? "highlighted" : ""
          }`}
        >
          <div className="instruction-color too-close-color"></div>
          <span>התרחק</span>
        </div>
      </div>{" "}
      {/* Centering guides - appear only when needed */}
      {showCenteringGuides && (
        <div className="centering-guides">
          <div className="guide-line vertical-line"></div>
          <div className="guide-line horizontal-line"></div>
        </div>
      )}
    </div>
  );
};

export default EnhancedFaceGuide;
